// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__KcZGk","Cell":"EmployeeTable_Cell__VrVd1","Paper":"EmployeeTable_Paper__p4NLD"};